export interface EmployerAddress {
  employerStreet: string;
  employerCity: string;
  employerState: string;
  employerZip: string;
}

export const EMPTY_EMPLOYER_ADDRESS: EmployerAddress = {
  employerStreet: '',
  employerCity: '',
  employerState: '',
  employerZip: '',
};

const FIELDS: { key: keyof EmployerAddress; label: string; span?: boolean }[] = [
  { key: 'employerStreet', label: 'Employer street', span: true },
  { key: 'employerCity', label: 'Employer city' },
  { key: 'employerState', label: 'Employer state' },
  { key: 'employerZip', label: 'Employer ZIP' },
];

export function employerAddressFrom(contact: {
  employerStreet?: string | null;
  employerCity?: string | null;
  employerState?: string | null;
  employerZip?: string | null;
}): EmployerAddress {
  return {
    employerStreet: contact.employerStreet ?? '',
    employerCity: contact.employerCity ?? '',
    employerState: contact.employerState ?? '',
    employerZip: contact.employerZip ?? '',
  };
}

export function employerAddressRequest(value: EmployerAddress) {
  return {
    employerStreet: value.employerStreet.trim() || null,
    employerCity: value.employerCity.trim() || null,
    employerState: value.employerState.trim() || null,
    employerZip: value.employerZip.trim() || null,
  };
}

export function EmployerAddressFields({
  idPrefix,
  value,
  onChange,
  labelClassName,
  inputClassName,
}: {
  idPrefix: string;
  value: EmployerAddress;
  onChange: (next: EmployerAddress) => void;
  labelClassName: string;
  inputClassName: string;
}) {
  return (
    <>
      {FIELDS.map(({ key, label, span }) => (
        <div key={key} className={span ? 'col-span-2' : undefined}>
          <label htmlFor={`${idPrefix}-${key}`} className={labelClassName}>{label}</label>
          <input
            id={`${idPrefix}-${key}`}
            type="text"
            value={value[key]}
            onChange={(e) => onChange({ ...value, [key]: e.target.value })}
            className={inputClassName}
          />
        </div>
      ))}
    </>
  );
}
